<template>
  <article class="preview preview--event" :class="classes">
    <safe-link :url="evt.link" class="preview__link preview__link--event">
      <img v-if="evt.image" class="preview__img" :src="image" :alt="evt.image.alt"/>
      <hgroup class="preview__hgroup">
        <h4 class="preview__type" :class="`preview__type--${type.tag}`">{{ type.name }}</h4>
        <h3 class="preview__event">{{ name }}</h3>
      </hgroup>
    </safe-link>

    <safe-link :url="evt.link" class="preview__content">
      <h5 class="preview__date" v-html="date"></h5>
      <p class="preview__description">{{ description }}</p>
      <span class="preview__plus"></span>
    </safe-link>
  </article>
</template>

<script>
import { clipText } from 'utils/text'
import { getDateTime } from 'utils/time'

export default {
  name: 'event-preview',
  props: {
    evt: Object,
    params: Object,
    featured: Boolean
  },

  computed: {
    image() { return (this.featured) ? this.evt.image.crops.featured : this.evt.image.url },
    date() { return getDateTime({ date: this.evt.date, template: '$d $M $Y', lang: 'fr' }) },
    name() { return this.evt.name[0].content },
    description() { return clipText(this.evt.description, 150) },
    type() {
      if (!this.evt.type) return { name: 'Événement', tag: 'event' }
      let [name, tag] = this.evt.type.split('[').map(w => {
        return w.replace(/]/, '').replace(/^ /, '').replace(/ $/, '')
      })

      return { name, tag }
    },
    classes() {
      return {
        'preview--nolink': !this.evt.link,
        'preview--featured': this.featured,
        'preview--inactive': this.evt.inactive
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EventPreview.vue?00075720